import React, { CSSProperties } from 'react';

interface SvgIconEmojiProps {
  style?: CSSProperties;
  color?: string;
}

const SvgIconEmoji: React.FC<SvgIconEmojiProps> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M14.8 11.2C15.1333 11.2 15.4167 11.0833 15.65 10.85C15.8833 10.6167 16 10.3333 16 10C16 9.66667 15.8833 9.38333 15.65 9.15C15.4167 8.91667 15.1333 8.8 14.8 8.8C14.4667 8.8 14.1833 8.91667 13.95 9.15C13.7167 9.38333 13.6 9.66667 13.6 10C13.6 10.3333 13.7167 10.6167 13.95 10.85C14.1833 11.0833 14.4667 11.2 14.8 11.2ZM9.2 11.2C9.53333 11.2 9.81667 11.0833 10.05 10.85C10.2833 10.6167 10.4 10.3333 10.4 10C10.4 9.66667 10.2833 9.38333 10.05 9.15C9.81667 8.91667 9.53333 8.8 9.2 8.8C8.86667 8.8 8.58333 8.91667 8.35 9.15C8.11667 9.38333 8 9.66667 8 10C8 10.3333 8.11667 10.6167 8.35 10.85C8.58333 11.0833 8.86667 11.2 9.2 11.2ZM12 16.4C12.9067 16.4 13.73 16.1433 14.47 15.63C15.21 15.1167 15.7467 14.44 16.08 13.6H7.92C8.25333 14.44 8.79 15.1167 9.53 15.63C10.27 16.1433 11.0933 16.4 12 16.4ZM12 20C10.8933 20 9.85333 19.79 8.88 19.37C7.90667 18.95 7.06 18.38 6.34 17.66C5.62 16.94 5.05 16.0933 4.63 15.12C4.21 14.1467 4 13.1067 4 12C4 10.8933 4.21 9.85333 4.63 8.88C5.05 7.90667 5.62 7.06 6.34 6.34C7.06 5.62 7.90667 5.05 8.88 4.63C9.85333 4.21 10.8933 4 12 4C13.1067 4 14.1467 4.21 15.12 4.63C16.0933 5.05 16.94 5.62 17.66 6.34C18.38 7.06 18.95 7.90667 19.37 8.88C19.79 9.85333 20 10.8933 20 12C20 13.1067 19.79 14.1467 19.37 15.12C18.95 16.0933 18.38 16.94 17.66 17.66C16.94 18.38 16.0933 18.95 15.12 19.37C14.1467 19.79 13.1067 20 12 20ZM12 18.4C13.7867 18.4 15.3 17.78 16.54 16.54C17.78 15.3 18.4 13.7867 18.4 12C18.4 10.2133 17.78 8.7 16.54 7.46C15.3 6.22 13.7867 5.6 12 5.6C10.2133 5.6 8.7 6.22 7.46 7.46C6.22 8.7 5.6 10.2133 5.6 12C5.6 13.7867 6.22 15.3 7.46 16.54C8.7 17.78 10.2133 18.4 12 18.4Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconEmoji;
